import { reportsApi } from '../reports.api';
import { CashFlowReportDto, PeriodDto } from '@sr/dto';

export type CashFlowQuery = {
  year: number,
  month?: number,
  managerId: number,
  bankAccountId: number,
  cashflowId: number,
};

const injectedApi = reportsApi.injectEndpoints({
  endpoints: (builder) => ({
    getCashFlowPeriods: builder.query<PeriodDto[], void>({
      query: () => ({
        url: 'cash-flow/periods',
        method: 'GET'
      })
    }),
    getCashFlow: builder.query<CashFlowReportDto[],CashFlowQuery>({
      query: ({ year, month, managerId, bankAccountId, cashflowId }) => {
        const params = new URLSearchParams({ year: String(year) });
        if (month !== undefined) params.set('month', String(month));
        if (managerId) params.set('managerId', String(managerId));
        if (bankAccountId) params.set('bankAccountId', String(bankAccountId));
        if (cashflowId) params.set('cashflowId', String(cashflowId));
        return `cash-flow?${params.toString()}`;
      }
    })
  })
});

export const cashFlowApi = injectedApi.enhanceEndpoints({
  addTagTypes: ['cash-flow'],
  endpoints: {}
});
